import React from "react";
import { getLang } from "../../store/uiStore";
import "./HomePage.css";

export default function HomePage() {
  const lang = getLang();

  const tr = {
    service:
      lang === "ru"
        ? "Служба государственного надзора здравоохранения и социальной защиты населения Республики Таджикистан"
        : "Хадамоти назорати давлатии тандурустӣ ва ҳифзи иҷтимоии аҳолии Ҷумҳурии Тоҷикистон",

    title: "Низоми ягона",

    subtitle:
      lang === "ru"
        ? "Современная государственная информационная система для цифровизации взаимодействия между частными медицинскими учреждениями и контролирующими органами, направленная на повышение прозрачности, эффективности и качества медицинских услуг."
        : "Низоми муосири давлатии иттилоотӣ барои рақамикунонии ҳамкорӣ байни муассисаҳои тиббии хусусӣ ва мақомоти назоратӣ, бо мақсади баланд бардоштани шаффофият, самаранокӣ ва сифати хизматрасониҳои тиббӣ.",

    about:
      lang === "ru"
        ? "О платформе"
        : "Дар бораи платформа",

    digital:
      lang === "ru"
        ? "Государственная политика цифровизации"
        : "Сиёсати давлатии рақамикунонӣ",

    audience:
      lang === "ru"
        ? "Для кого предназначена платформа"
        : "Платформа барои кӣ пешбинӣ шудааст",

    modules:
      lang === "ru"
        ? "Основные разделы системы"
        : "Бахшҳои асосии система",

    benefits:
      lang === "ru"
        ? "Основные преимущества"
        : "Афзалиятҳои асосӣ",

    footer:
      lang === "ru"
        ? "Единая система для современного управления и качественного контроля"
        : "Системаи ягона барои идоракунии муосир ва назорати босифат",

    slogan:
      lang === "ru"
        ? "Надёжность | Прозрачность | Эффективность"
        : "Эътимоднокӣ | Шаффофият | Самаранокӣ",
  };

  const list = {
    about:
      lang === "ru"
        ? [
            "Ведение единого электронного реестра частных клиник Республики Таджикистан",
            "Онлайн-приём срочных уведомлений",
            "Электронный приём отчётности частных клиник",
            "Уведомления о сроках отчётности",
            "Мониторинг и анализ в режиме реального времени",
            "Развитие электронного взаимодействия между учреждениями и государственными органами",
          ]
        : [
            "Пешбурди феҳристи ягонаи электронии клиникаҳои хусусии Ҷумҳурии Тоҷикистон",
            "Қабули онлайнии огоҳиномаҳои фаврӣ",
            "Қабули электронии ҳисоботҳои клиникаҳои хусусӣ",
            "Ирсоли огоҳиномаҳо оид ба муҳлатҳои ҳисоботдиҳӣ",
            "Мониторинг ва таҳлил дар реҷаи воқеӣ",
            "Такмили ҳамкории электронӣ байни муассисаҳо ва мақомоти давлатӣ",
          ],

    modules:
      lang === "ru"
        ? [
            "Реестр частных клиник",
            "Срочные уведомления",
            "Электронная отчётность",
            "Календарь отчётных сроков",
            "Панель инспектора",
            "Управленческие панели",
          ]
        : [
            "Феҳристи клиникаҳои хусусӣ",
            "Огоҳиномаҳои фаврӣ",
            "Ҳисоботдиҳии электронӣ",
            "Тақвими муҳлатҳои ҳисоботӣ",
            "Панели нозир",
            "Панелҳои идоракунӣ",
          ],

    benefits:
      lang === "ru"
        ? [
            "Снижение бумажного документооборота",
            "Ускорение передачи данных",
            "Прозрачный и эффективный контроль",
            "Доступ к данным в реальном времени",
            "Повышение качества управления",
          ]
        : [
            "Кам шудани ҳуҷҷатгузории қоғазӣ",
            "Суръатбахшии ирсоли маълумот",
            "Назорати шаффоф ва самаранок",
            "Дастрасӣ ба маълумот дар реҷаи воқеӣ",
            "Баланд шудани сифати идоракунӣ",
          ],
  };

  return (
    <main className="nizom-home">
      <div className="nizom-home-container">
        <section className="nizom-home-hero">
          <div className="nizom-home-service">{tr.service}</div>

          <h1 className="nizom-home-title">{tr.title}</h1>

          <p className="nizom-home-subtitle">{tr.subtitle}</p>
        </section>

        <Section title={tr.about} items={list.about} />
        <Section
          title={tr.digital}
          text={
            lang === "ru"
              ? "Платформа создана в рамках государственной политики цифровизации и направлена на повышение прозрачности, эффективности контроля и упрощение отчётности."
              : "Платформаи мазкур дар доираи сиёсати давлатии рақамикунонӣ таъсис дода шуда, ба баланд бардоштани шаффофият, самаранокии назорат ва соддагардонии ҳисоботдиҳӣ равона шудааст."
          }
        />
        <Section title={tr.modules} items={list.modules} />
        <Section title={tr.benefits} items={list.benefits} />

        <footer className="nizom-home-footer">
          <div className="nizom-home-footer-title">{tr.footer}</div>
          <div className="nizom-home-footer-text">{tr.slogan}</div>
        </footer>
      </div>
    </main>
  );
}

function Section({ title, text, items }) {
  return (
    <section className="nizom-home-section">
      <h2 className="nizom-home-section-title">{title}</h2>

      {text && <p className="nizom-home-text">{text}</p>}

      {items && (
        <ul className="nizom-home-list">
          {items.map((item, i) => (
            <li key={i} className="nizom-home-list-item">
              <span className="nizom-home-check" aria-hidden="true">
                ✓
              </span>
              <span>{item}</span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
